import React from "react";
import styled from "styled-components";
import {CustomStyledArrow, LeftCarouselArrow, RightCarouselArrow} from "../../../../global/style";

const CustomStyledLeftArrow = styled(CustomStyledArrow)`
  ${({specialsType}) => {
    return (specialsType && specialsType !== "appointment") && `
    left: calc(4% - 15px);
  `
  }};

  ${({specialsType}) => specialsType && specialsType === "gallery" && `left: 6px;top: 43%;`};

  ${({floorplans}) => floorplans && ` 
    top: 15%;
    transform: translateY(-17%);
    left: calc(6% - 7px);
    `
};

  @media screen and (min-width: ${(props) => props.theme.screenSizes.breakSmall}) {
    ${({floorplans}) => floorplans && ` 
    top: 23%;
    transform: translateY(-23%);
    left: 17px;
  `};
    ${({specialsType}) => specialsType && specialsType === "gallery" && `left: 43px;top: 43%;`};
  }

  @media screen and (min-width: ${(props) => props.theme.screenSizes.breakLaptop}) {
    ${({floorplans}) => floorplans && ` 
    top: 50%;
    transform: translateY(-50%);
  `};
    ${({specialsType}) => specialsType && specialsType === "gallery" && `left: 125px;`};
  }
`;

const CustomLeftArrow = ({onClick, specialsType, floorplans}) => {

  return (
    <CustomStyledLeftArrow
      tabIndex={0}
      className="CustomLeftArrow"
      onClick={onClick}
      onKeyPress={onClick}
      specialsType={specialsType}
      floorplans={floorplans}
    >
      <LeftCarouselArrow className="LeftCarouselArrow"/>
    </CustomStyledLeftArrow>
  )
};

const CustomStyledRightArrow = styled(CustomStyledArrow)`

  ${({specialsType}) => {
  return specialsType !== "appointment" && ` right: calc(4% - 10px);`
}};

  ${({specialsType}) => specialsType && specialsType === "gallery" && `right: 6px;top: 43%;`};

  ${({floorplans}) => floorplans && ` 
    top: 15%;
    right:2.5%;
    transform: translateY(-17%)
  `};

  @media screen and (max-width: ${(props) => props.theme.screenSizes.breakMobile}) {
      ${({floorplans}) => floorplans && ` 
        right:1%;
      `};
  }

  @media screen and (min-width: ${(props) => props.theme.screenSizes.breakSmall}) {
    ${({specialsType}) => {
  return specialsType !== "appointment" && `right: calc(2% - 0px);`
}};
    ${({floorplans}) => floorplans && ` 
    top: 23%;
    transform: translateY(-23%);
  `};

    ${({specialsType}) => specialsType && specialsType === "gallery" && `right: 41px;top: 43%;`};
  }

  @media screen and (min-width: ${(props) => props.theme.screenSizes.breakMedium}) {
    ${({specialsType}) => {
  return specialsType !== "appointment" && `right: calc(4% - 0px);`
}};
    ${({floorplans}) => floorplans && ` 
    top: 23%;
    transform: translateY(-23%);
  `};

    ${({specialsType}) => specialsType && specialsType === "gallery" && `right: 41px;top: 43%;`};
  }

  @media screen and (min-width: ${(props) => props.theme.screenSizes.breakLaptop}) {
    ${({floorplans}) => floorplans && ` 
    top: 50%;
    transform: translateY(-50%);
  `};

    ${({specialsType}) => specialsType && specialsType === "gallery" && `right: 107px;`};
  }
`;

const CustomRightArrow = ({onClick, specialsType, floorplans}) => {
  return (
    <CustomStyledRightArrow
      tabIndex={0}
      className="CustomRightArrow"
      onClick={onClick}
      onKeyPress={onClick}
      specialsType={specialsType}
      floorplans={floorplans}
    >
      <RightCarouselArrow className="RightCarouselArrow"/>
    </CustomStyledRightArrow>
  )
};

export {
  CustomLeftArrow,
  CustomRightArrow
}